import { X } from 'lucide-react';
import { create } from 'zustand';

interface ConfirmationModalState {
  isOpen: boolean;
  isStaking: boolean;
  onConfirm: (() => void) | undefined;
  onCancel: (() => void) | undefined;
  setOpen: (open: boolean, isStaking?: boolean, onConfirm?: (() => void) | undefined, onCancel?: (() => void) | undefined) => void;
}

export const useConfirmationModal = create<ConfirmationModalState>((set) => ({
  isOpen: false,
  isStaking: false,
  onConfirm: undefined,
  onCancel: undefined,
  setOpen: (open, isStaking = false, onConfirm = undefined, onCancel = undefined) => 
    set({ isOpen: open, isStaking, onConfirm, onCancel }),
}));

export default function ConfirmationModal() {
  const { isOpen, isStaking, onConfirm, onCancel, setOpen } = useConfirmationModal();

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    setOpen(false);
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    setOpen(false);
  };

  return (
    <div className="fixed inset-0 bg-quantum-dark/80 backdrop-blur-lg flex items-center justify-center z-50">
      <div className="quantum-card w-full max-w-md p-6 relative">
        <button
          onClick={handleCancel}
          className="absolute top-4 right-4 text-quantum-light/50 hover:text-quantum-light"
        >
          <X className="w-5 h-5" />
        </button>

        <h3 className="text-xl font-bold text-quantum-light mb-4">Important Information</h3>
        
        <div className="space-y-4">
          <div className="quantum-card p-4 bg-quantum-primary/10 border border-quantum-primary/20">
            <h4 className="font-medium text-quantum-primary mb-2">Token Distribution</h4>
            <p className="text-sm text-quantum-light/80 mb-2">
              Purchased tokens will be distributed after the presale ends.
            </p>
            {isStaking && (
              <p className="text-sm text-quantum-light/80">
                <span className="font-medium text-quantum-primary">Staked tokens</span> will be locked for 7 days after launch.
              </p>
            )}
          </div>
          
          <div className="quantum-card p-4 bg-white/5">
            <p className="text-sm text-quantum-light/80">
              By proceeding, you confirm that you have read and understand the above information.
            </p>
          </div>
          
          <div className="flex gap-3 mt-4">
            <button
              onClick={handleCancel}
              className="flex-1 py-2 px-4 bg-white/10 hover:bg-white/15 rounded text-quantum-light transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="flex-1 py-2 px-4 quantum-button"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 